import React from 'react';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'A simple blood draw',
    desc: 'Takes minutes. Completely comfortable.'
  }, {
    num: '02',
    title: 'Your plasma, concentrated',
    desc: 'Spun to isolate growth factors your scalp needs.'
  }, {
    num: '03',
    title: 'Delivered directly',
    desc: 'Injected into the scalp over 3–4 sessions to reawaken follicles.'
  }];
  return <section className="bg-cream py-20 md:py-32 px-4" data-id="element-122">
      <div className="max-w-7xl mx-auto" data-id="element-123">
        <h2 className="font-serif text-3xl md:text-5xl text-espresso text-center mb-16 md:mb-24" data-id="element-124">
          How It Works
        </h2>

        <div className="relative" data-id="element-125">
          {/* Desktop connecting line */}
          <div className="hidden md:block absolute top-[40px] left-[15%] right-[15%] h-px bg-divider" aria-hidden="true" data-id="element-126" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-127">
            {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-128">
                <div className="w-20 h-20 rounded-full bg-white border border-divider flex items-center justify-center mb-8 shadow-sm" data-id="element-129">
                  <span className="font-serif text-3xl text-gold" data-id="element-130">
                    {step.num}
                  </span>
                </div>
                <h3 className="font-serif text-2xl text-espresso mb-4" data-id="element-131">
                  {step.title}
                </h3>
                <p className="font-sans text-base text-muted-foreground leading-relaxed max-w-xs" data-id="element-132">
                  {step.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}